export default {"src":"/_next/static/media/stars.5bbea46c.svg","height":202,"width":241,"blurWidth":0,"blurHeight":0};